import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

import Homepage from './pages/homepage/homepage';
import './app.styles.scss';

const Header = lazy(() => import('./components/header/header'));
const SideBar = lazy(() => import('./components/sidebar/sidebar'));
const About = lazy(() => import('./pages/about/about'));
const Contact = lazy(() => import('./pages/contact/contact'));
const Schedule = lazy(() => import('./pages/schedule/schedule'));
const Footer = lazy(() => import('./components/footer/footer'));



const App = () => (
  <div>
    <Suspense fallback={<div>Loading..</div>}>
      <Header />
      <SideBar />
      <Switch>
          <Route exact path={['/', '/index.html']} component={Homepage} />
          <Route exact path='/about' component={About} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/schedule' component={Schedule} />
      </Switch>
      <Footer />
    </Suspense>
  </div>
)

export default App;
